import React from "react";
import { Link } from "react-router-dom";
import { menuItems } from "../config/webSiteNavigation.config";
import { DOMAIN_CONFIG, getPortalUrl } from "../config/domains";

const DesktopNav = ({ location }) => {
  // On static site, auth links should point to portal domain
  const loginUrl = DOMAIN_CONFIG.IS_STATIC_SITE ? getPortalUrl('/login') : '/login';
  const signupUrl = DOMAIN_CONFIG.IS_STATIC_SITE ? getPortalUrl('/signup') : '/signup';

  return (
    <div className="hidden md:flex space-x-6 items-center">
      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`hover:text-secondary ${
            location.pathname === item.path ? "text-secondary underline" : ""
          }`}
        >
          {item.label}
        </Link>
      ))}

      {DOMAIN_CONFIG.IS_STATIC_SITE ? (
        <>
          <a
            href={loginUrl}
            className="bg-white text-black border px-4 py-2 rounded-lg hover:bg-primary-dark"
          >
            Login
          </a>
          <a
            href={signupUrl}
            className="bg-[#1E6C56] text-white px-4 py-2 rounded-lg hover:bg-primary-dark"
          >
            Signup
          </a>
        </>
      ) : (
        <>
          <Link
            to="/login"
            className="bg-white text-black border px-4 py-2 rounded-lg hover:bg-primary-dark"
          >
            Login
          </Link>
          <Link
            to="/signup"
            className="bg-[#1E6C56] text-white px-4 py-2 rounded-lg hover:bg-primary-dark"
          >
            Signup
          </Link>
        </>
      )}
      <Link
        to="https://www.nkenne.com"
        target="_blank"
        className="text-black px-4 py-2 rounded-lg hover:bg-primary-dark"
      >
        Try NKENNE app
      </Link>
    </div>
  );
};

export default DesktopNav;
